import { render, staticRenderFns } from "./BulkReplyTemplates.vue?vue&type=template&id=54495ffc&scoped=true&"
import script from "./BulkReplyTemplates.vue?vue&type=script&lang=js&"
export * from "./BulkReplyTemplates.vue?vue&type=script&lang=js&"
import style0 from "./BulkReplyTemplates.vue?vue&type=style&index=0&id=54495ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54495ffc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
